import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js"

jQuery(function($){
    flatpickr(".flatpickr", {
        locale: French,
        altInput: true,
        disableMobile: true,
        altFormat: "d/m/Y",
        dateFormat: "Ymd",
    });
});